import {
  makeStyles,
  shorthands,
  tokens,
  type GriffelStyle,
} from "@fluentui/react-components";
import { iconFilledClassName } from "@fluentui/react-icons";
import type { Appearance } from "../../data";

type Styles = {
  bookMarks: GriffelStyle;
  spinner: GriffelStyle;
  bookmark: GriffelStyle;
  icon: GriffelStyle;
};

const defaultStyles: Styles = {
  bookMarks: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    height: "24px",
    ...shorthands.gap("4px"),
  },

  spinner: {
    ...shorthands.border("0px"),
    ...shorthands.padding("0px"),
  },

  bookmark: {
    ...shorthands.border("0px"),
    ...shorthands.padding("0px"),
    minWidth: "24px",
    maxWidth: "24px",
  },

  icon: {
    fontSize: "20px",
    [`&.${iconFilledClassName}`]: {
      color: tokens.colorBrandForeground1,
    },
  },
};

const copilotLabStyles: Styles = {
  ...defaultStyles,
};

const copilotLabGoBoldStyles: Styles = {
  ...defaultStyles,

  bookMarks: {
    ...defaultStyles.bookMarks,
    height: "20px",
  },

  bookmark: {
    ...defaultStyles.bookmark,
    height: "20px",
    minWidth: "20px",
    maxWidth: "20px",
  },

  icon: {
    ...defaultStyles.icon,
    fontSize: "16px",
  },
};

const inAppStyles: Styles = {
  ...defaultStyles,
};

const m365Styles: Styles = {
  ...defaultStyles,
};

const singleColumnStyles: Styles = {
  ...defaultStyles,

  bookmark: {
    minWidth: "24px",
    maxWidth: "24px",
    ...shorthands.border("0px"),
    ...shorthands.padding("8px", "0px"),
  },

  icon: {
    fontSize: "16px",
  },
};

const useInAppStyles = makeStyles(inAppStyles);
const useCopilotLabStyles = makeStyles(copilotLabStyles);
const useCopilotLabGoBoldStyles = makeStyles(copilotLabGoBoldStyles);
const useM365Styles = makeStyles(m365Styles);
const useSingleColumnStyle = makeStyles(singleColumnStyles);

export const useStyles = (appearance?: Appearance) => {
  switch (appearance) {
    case "in-app":
      return useInAppStyles;
    case "web":
      return useCopilotLabStyles;
    case "web-v2":
      return useCopilotLabGoBoldStyles;
    case "m365":
    case "bing-web":
    case "win-copilot":
      return useM365Styles;
    case "bing-mobile":
    case "underside":
    case "single-col":
      return useSingleColumnStyle;
    default:
      return useInAppStyles;
  }
};
